
export enum Language {
  EN_GB = 'en-GB',
  PT_PT = 'pt-PT'
}

export type Role = 'user' | 'assistant';

export interface Message {
  id: string;
  role: Role;
  text: string;
  timestamp: Date;
}

export interface User {
  name: string;
  type: 'admin' | 'guest';
}

export interface ChatSession {
  id: string;
  title: string;
  messages: Message[];
  language: Language;
  updatedAt: number;
}

export interface VoiceState {
  isListening: boolean;
  isProcessing: boolean;
  isSpeaking: boolean;
  error: string | null;
}

export enum AppStatus {
  IDLE = 'idle',
  LISTENING = 'listening',
  PROCESSING = 'processing',
  SPEAKING = 'speaking',
  ERROR = 'error'
}
